import { config } from 'config';

const redirectToTutorPricing = () => {
  window.open(`${config.appDomain}/dashboard/tutor/subscription/pricing`, '_self');
};

export default redirectToTutorPricing;
